import * as React from "react";
import { Alert } from "components/bootstrap";
const DestinationPermissionAlert = ({ sectionName }) => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, `You currently do not have the permissions to view or manage ${sectionName} destination.`);
export default DestinationPermissionAlert;
